/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorInquiryDto } from '../../models/vendor-inquiry-dto';

export interface VendorInquiryControllerFindById$Params {
  id: string;
}

export function vendorInquiryControllerFindById(http: HttpClient, rootUrl: string, params: VendorInquiryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, vendorInquiryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorInquiryDto>;
    })
  );
}

vendorInquiryControllerFindById.PATH = '/api/v1/vendorInquiry/{id}';
